import React, { useState } from 'react';
import DailyDirection from './DailyDirection';
import OpenPositions from './OpenPositions';
import ScoutKpis, { Scope, InstrumentFilter } from './ScoutKpis';
import EntryReviewsLatest from '../LiveMonitor/components/EntryReviewsLatest';
import ScoutWatchTriggers from '../LiveMonitor/components/ScoutWatchTriggers';
import ScoutExitReviews from '../LiveMonitor/components/ScoutExitReviews';
import './LLM.css';

type LLMTab = 'entry-reviews' | 'triggers' | 'exit-reviews';

/** Dedicated page for the experimental LLM-driven scout (NG / OIL / US500).
 *
 * Top:    Daily Direction — human-in-the-loop bias setter (gates all entries)
 * Middle: KPI cards + scope/instrument filters (shared across tabs)
 * Bottom: Three tabs — Entry Reviews / Triggers / Exit Reviews
 */
const LLM: React.FC = () => {
  const [scope, setScope] = useState<Scope>('today');
  const [instrumentFilter, setInstrumentFilter] = useState<InstrumentFilter>('ALL');
  const [activeTab, setActiveTab] = useState<LLMTab>('entry-reviews');

  return (
    <div className="llm-page">
      <header className="llm-header">
        <h1>LLM Scout</h1>
        <p className="llm-subtitle">
          Human-in-the-loop structural trading across NATURALGAS, OIL_CRUDE, US500.
          You set the daily direction; the LLM finds the entry, sizes the trade,
          and manages exits structurally.
        </p>
      </header>

      <section className="llm-section">
        <DailyDirection />
      </section>

      <section className="llm-section">
        <OpenPositions />
      </section>

      <section className="llm-section">
        <h2 className="llm-section-title">Performance</h2>
        <ScoutKpis
          scope={scope}
          setScope={setScope}
          instrumentFilter={instrumentFilter}
          setInstrumentFilter={setInstrumentFilter}
        />
      </section>

      <section className="llm-section">
        <div className="monitor-tabs">
          <button
            className={`monitor-tab ${activeTab === 'entry-reviews' ? 'tab-active' : ''}`}
            onClick={() => setActiveTab('entry-reviews')}
          >
            Entry Reviews
          </button>
          <button
            className={`monitor-tab ${activeTab === 'triggers' ? 'tab-active' : ''}`}
            onClick={() => setActiveTab('triggers')}
          >
            Triggers
          </button>
          <button
            className={`monitor-tab ${activeTab === 'exit-reviews' ? 'tab-active' : ''}`}
            onClick={() => setActiveTab('exit-reviews')}
          >
            Exit Reviews
          </button>
        </div>

        {activeTab === 'entry-reviews' && <EntryReviewsLatest />}
        {activeTab === 'triggers' && <ScoutWatchTriggers />}
        {activeTab === 'exit-reviews' && (
          <ScoutExitReviews scope={scope} instrumentFilter={instrumentFilter} />
        )}
      </section>
    </div>
  );
};

export default LLM;
